import {
  Box,
  Container,
  Typography,
  Grid,
  Link,
  Divider,
} from '@mui/material';
import { Phone as PhoneIcon, Schedule as ScheduleIcon, LocationOn as LocationIcon } from '@mui/icons-material';
import { useLanguage } from '../i18n/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <Box component="footer" sx={{ backgroundColor: 'primary.main', color: 'white', py: 6, mt: 8 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#fdfaf1',
                  borderRadius: 2,
                  p: 1,
                  mr: 2,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
                }}
              >
                <Box
                  component="img"
                  src="/images/chato_hs_logo.png"
                  alt="Chato Home Services Logo"
                  sx={{ height: 48, width: 'auto', display: 'block' }}
                />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Chato Home Services
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              {t('footer.tagline')}
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {t('footer.serviceHours')}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <ScheduleIcon sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">{t('footer.hoursValue')}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <PhoneIcon sx={{ mr: 1, fontSize: 20 }} />
              <Link href="tel:555-555-5555" color="inherit" underline="hover" sx={{ fontWeight: 600 }}>
                555-555-5555
              </Link>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <LocationIcon sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">{t('footer.location')}</Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {t('footer.emergencyTitle')}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
              {t('footer.emergencyText')}
            </Typography>
            <Link
              href="tel:555-555-5555"
              sx={{ display: 'inline-flex', alignItems: 'center', color: 'secondary.main', textDecoration: 'none', fontWeight: 600, '&:hover': { textDecoration: 'underline' } }}
            >
              <PhoneIcon sx={{ mr: 1 }} />
              {t('footer.callNow')}
            </Link>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, backgroundColor: 'rgba(255, 255, 255, 0.2)' }} />

        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            © {new Date().getFullYear()} Chato Home Services. {t('footer.rights')}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            {t('footer.badges')}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
